export default __webpack_public_path__ + "static/media/facebook.5b5e71b7.svg";